import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["shareData"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import useSearchParameter from 'hooks/useSearchParameter';
import ShareContentModal from 'screens/ShareModal';
import FormField from 'components/FormField';
import InlineList from 'components/InlineList';
import Button from 'components/Button';
import { TEAM_ICONS } from 'utils/icons';
import { hasPrivilege } from 'utils/privileges';
import config from 'utils/config';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function ShareNowField(_ref) {
  var shareData = _ref.shareData,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId();
  var _useSearchParameter = useSearchParameter('type'),
    _useSearchParameter2 = _slicedToArray(_useSearchParameter, 2),
    type = _useSearchParameter2[0],
    setType = _useSearchParameter2[1];
  var isContentAdmin = hasPrivilege('asset_read') || hasPrivilege('playlist_read');
  if (!isContentAdmin) {
    return null;
  }
  var adminsCanShareWithEveryone = config.everyoneSharing !== false;
  var isNotAdminContent = shareData.overallContentAudienceType !== 'admin';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
      as: "span",
      label: t('form_share_with'),
      labelId: uniqueId
    }, otherProps), {}, {
      children: /*#__PURE__*/_jsxs(InlineList, {
        spacing: "s",
        children: [/*#__PURE__*/_jsx(Button, {
          icon: "user",
          onClick: function onClick() {
            return setType('users');
          },
          children: t('state_individual_users')
        }), isNotAdminContent && /*#__PURE__*/_jsx(Button, {
          icon: TEAM_ICONS.TEAM,
          onClick: function onClick() {
            return setType('teams');
          },
          children: t('content_type_team_plural')
        }), isNotAdminContent && adminsCanShareWithEveryone && /*#__PURE__*/_jsx(Button, {
          icon: "globe",
          onClick: function onClick() {
            return setType('everyone');
          },
          children: t('state_everyone')
        })]
      })
    })), !!type && /*#__PURE__*/_jsx(ShareContentModal, {
      data: shareData,
      onClose: function onClose() {
        return setType(undefined);
      },
      initialShareType: type
    })]
  });
}
export default ShareNowField;